export default "/images/vendor/quill/icons/video.svg?eaeee04ce09d795ae77deaff36281c80";